import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import ArrowIcon from 'dibs-icons/exports/ArrowRight';

import styles from './SbSharedCollectionsModulesHeroModule.scss';

function SbSharedCollectionsModulesHeroModuleComponent({ collectionsModules, renderImage }) {
    const { photo, title, subtitle, description, link, linkText, variation } = collectionsModules;

    const renderImageProps = {
        photo,
        src: photo,
        imgClassName: styles.image,
        alt: title || subtitle || '',
    };

    return (
        <div
            className={classnames(styles.wrapperFullWidth, {
                [styles.firstVariation]: variation === '1',
                [styles.secondVariation]: variation === '2',
            })}
        >
            {photo && <div className={styles.imgWrapper}>{renderImage(renderImageProps)}</div>}
            <div className={`rowFlex ${styles.innerPageWidth}`}>
                <div className={`colLg8 colMd8 colXs12 ${styles.moduleWrapper}`}>
                    <div className={styles.module}>
                        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
                        {title && <div className={styles.title}>{title}</div>}
                        {description && (
                            <div
                                className={styles.description}
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                        )}

                        {link && linkText && (
                            <a href={link} className={styles.link}>
                                {linkText}
                                <ArrowIcon className={styles.arrow} />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

SbSharedCollectionsModulesHeroModuleComponent.propTypes = {
    collectionsModules: PropTypes.object.isRequired,
    renderImage: PropTypes.func.isRequired,
};

export const SbSharedCollectionsModulesHeroModule = createFragmentContainer(
    SbSharedCollectionsModulesHeroModuleComponent,
    {
        collectionsModules: graphql`
            fragment SbSharedCollectionsModulesHeroModule_collectionsModules on CollectionsModulesHero {
                photo
                title
                subtitle
                description
                link
                linkText
                variation
            }
        `,
    }
);
